import "../styles/home/Section2.css";

const Section2Network2 = () => {
  return (
    <section
      className="htmlblock"
      style={{ backgroundColor: "white", minHeight: "0px" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-5">
            <h2 style={{ margin: "0", color: "black" }}>WHAT STARTUPS SAY </h2>
          </div>
          <br />
         
        </div>
      </div>
    </section>
  );
};

export default Section2Network2;
